// extracted by mini-css-extract-plugin
export var askAiIcon = "_mf-j";
export var category = "_mf-9";
export var categoryHeader = "_mf-e";
export var container = "_mf-0";
export var group = "_mf-a";
export var groupItems = "_mf-f";
export var groupSeparator = "_mf-k";
export var loading = "_mf-1";
export var noResults = "_mf-3";
export var placeholder = "_mf-2";
export var resultContent = "_mf-5";
export var resultIcon = "_mf-c";
export var resultItem = "_mf-g";
export var resultMeta = "_mf-8";
export var resultSubtitle = "_mf-7";
export var resultSuffix = "_mf-i";
export var resultTitle = "_mf-6";
export var resultsList = "_mf-4";
export var searchGroup = "_mf-d";
export var selected = "_mf-h";
export var subgroup = "_mf-b";